import React from 'react';
import { useAtom } from 'jotai';
import { Icon } from '@pairy/pds-react';

import useUpdateViewerPageState from '../../../../../hooks/useUpdateViewerPageState';
import { isDisableHelpersAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

export interface Props {
  variant: 'prev' | 'next';
  totalPage: number;
  isNextPageButtonDisabled?: boolean;
  updatePrevThumbnails?: (page: number) => void;
  updateNextThumbnails?: (page: number) => void;
}

const MobilePageMoveButton = ({
  variant,
  totalPage,
  isNextPageButtonDisabled,
  updatePrevThumbnails,
  updateNextThumbnails,
}: Props) => {
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  const { updateCurrentPage, currentPage } = useUpdateViewerPageState();

  const handleClickPrevButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === 1) {
      return;
    }

    updatePrevThumbnails?.(currentPage - 1);
    updateCurrentPage(currentPage - 1);
  };

  const handleClickNextButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    if (currentPage === totalPage) {
      return;
    }

    if (isNextPageButtonDisabled) {
      return;
    }

    updateNextThumbnails?.(currentPage + 1);
    updateCurrentPage(currentPage + 1);
  };

  const getIsDisable = () => {
    if (variant === 'prev' && currentPage === 1) {
      return 'disable';
    }

    if (
      (variant === 'next' && currentPage === totalPage) ||
      isNextPageButtonDisabled
    ) {
      return 'disable';
    }

    return '';
  };

  return (
    <Styled.ArrowButton
      className={[getIsDisable(), variant].join(' ')}
      onClick={
        variant === 'prev' ? handleClickPrevButton : handleClickNextButton
      }
      paddingX={8}
    >
      <Icon
        icon={`ph:caret-${variant === 'next' ? 'right' : 'left'}`}
        size={19}
        color="black"
      />
    </Styled.ArrowButton>
  );
};

export default MobilePageMoveButton;
